module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"AI Recommended Keyword Guide","description_title":"Write a review about the recommended keywords.","description_content":"Don\u0027t worry about what to write; try writing a review using the recommended keywords. AI analyzes the text to determine if it covers the keywords.","disclaimer":"*AI analysis may have errors, which could affect the actual reward amount paid."}}')
  delete Component.options._Ctor
}
